import React from "react";
import { Line } from "react-konva";

import { HotspotProps } from "./Hotspot";

interface Props extends HotspotProps {}

const PolygonHotspot: React.FC<React.PropsWithChildren<Props>> = (props) => {
  return (
    <Line closed points={props.coords} {...props} onClick={props.onClick} />
  );
};

export default PolygonHotspot;
